/*!

=========================================================
* Argon Dashboard PRO React - v1.2.5
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

// Solo los estilos que realmente tienes
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/scss/argon-dashboard-pro-react.scss";
import "assets/css/autocomplete.css";
import "assets/css/table-styles.css";

// Solo tu contexto de autenticación
import { AuthProvider } from "contexts/AuthContext";

// Layouts
import UserLayout from "layouts/User.js";
import PublicLayout from "layouts/Public.js";
import ExternalFormularyLayout from "layouts/ExternalFormulary.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        {/* Public routes - must be before catch-all routes */}
        <Route path="/offers/*" element={<PublicLayout />} />
        <Route path="/external/application/*" element={<ExternalFormularyLayout />} />
        {/* Auth routes - redirect to main menu */}
        <Route path="/auth/login" element={<Navigate to="/main-menu" replace />} />
        {/* Default redirects */}
        <Route path="/" element={<Navigate to="/main-menu" replace />} />
        {/* Protected routes - catch-all must be last */}
        <Route path="/*" element={<UserLayout />} />
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);
